import { useMutation, gql } from "@apollo/client";
import { TaskResponse } from "./useCompleteTask";

const START_PROCESS = gql`
  mutation ($key: String, $data: Json) {
    startProcess(key: $key, data: $data) {
      formDefinition
      taskId
      processInstanceId
      data
    }
  }
`;

export type StartProcessTaskResponse = TaskResponse;

export const useStartProcess = (key: string | undefined, data?: object) => {
  const [startProcess, { loading, error, reset }] = useMutation<{
    startProcess: StartProcessTaskResponse;
  }>(START_PROCESS, {
    variables: {
      key,
      data,
    },
  });

  return {
    loading,
    error,
    reset,
    startProcess,
  };
};
